export default __webpack_public_path__ + "static/media/sabonItalic.a76bf6f9.ttf";